import { ACTIVE_PAGE, JOB_LIST,INTERN_JOB_LIST, SET_LOCAL_FILTER,UPDATE_JOB_APPLICATION_STATUS } from "../Actions/types";

const initialState = {
  jobs: [],
  internJobs:[],
  activePage : 0,
  localFilter: {}
}


export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case JOB_LIST:
      return { ...state, jobs: payload }
    case INTERN_JOB_LIST:
      return { ...state, internJobs: payload }
    case ACTIVE_PAGE:
      return { ...state, activePage: payload }
    case SET_LOCAL_FILTER:
      return { ...state, localFilter: payload }
    case UPDATE_JOB_APPLICATION_STATUS:
  return {
    ...state,
    jobs: {
      ...state.jobs,
      data: state.jobs.data.map(job =>
        job.job_id === action.payload.job_id
          ? { ...job, application_status: action.payload.application_status }
          : job
      )
    }
  };
    default:
      return state;
  }
} 